module.exports = __webpack_public_path__ + "media/images/chat_icon_pikkachan-3c05eefea7dab5f80a3ad9ba42a1f6d1.png";